import React from "react";

import styles from "./ModalBackground.module.css";

export default function ModalBackground() {
  return <div className={styles.container}></div>;
}
